export default __webpack_public_path__ + "images/8892fc0522116cdb61b225bd09d78c26.svg";